"use client";

import {useMemo} from "react";
import {usePathname} from "next/navigation";
import {useTranslation} from "react-i18next";
import type {PreviewStarter} from "@/components/chat/GailLauncherPreview";
import {usePermissions} from "@/hooks/usePermissions";
import {resolveLauncherPage} from "@/utils/chat/launcherPages";

/** Translated starters the person may use from the corner launcher on this page. */
export function useLauncherPage() {
  const { t } = useTranslation("ask");
  const pathname = usePathname() ?? "";
  const { canAccess } = usePermissions();
  const page = useMemo(() => resolveLauncherPage(pathname), [pathname]);

  const starters: PreviewStarter[] = (page?.starters ?? [])
    .filter((starter) => !starter.requires || canAccess(starter.requires.data, starter.requires.level))
    .map((starter) => ({ ...starter, text: t(`launcher.starters.${starter.id}`) }));

  return {
    heading: page ? t(`launcher.pages.${page.key}.heading`) : "",
    // A preview without a question about the page would only offer changes, so it isn't shown.
    starters: starters.some((starter) => starter.kind === "read") ? starters : [],
  };
}

